let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4hOv8"), load("fhU7k")]).then(() => parcelRequire('cJyjM'));